var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { loadFilterFromUrl } from '../../utils/loaderv2';
import { useFilterConfigStore } from '../filterConfigurationStore';
import { useFilterStore } from '../filterStore';
export var legacyFilterUrls = {
    'riktenx:filterscape': 'https://raw.githubusercontent.com/riktenx/filterscape/refs/heads/main/filter.rs2f',
    'typical-whack:loot-filters-modules': 'https://raw.githubusercontent.com/typical-whack/loot-filters-modules/refs/heads/main/filter.rs2f',
    'Blooprnt:ClearLoot': 'https://raw.githubusercontent.com/Blooprnt/ClearLoot/refs/heads/main/clearloot.rs2f',
};
var LAST_MIGRATION_DATE = '2025-04-19';
export var requiresMigration = function () {
    var legacyData = localStorage.getItem('modular-filter-storage');
    if (!legacyData) {
        return false;
    }
    var migrated = localStorage.getItem('modular-filter-storage-migrated');
    if (!migrated) {
        return true;
    }
    try {
        var date = Date.parse(migrated);
        if (date < new Date(LAST_MIGRATION_DATE).getTime() || isNaN(date)) {
            return true;
        }
        return false;
    }
    catch (error) {
        console.error('error checking for migration', error);
        return true;
    }
};
export var MigrateLegacyData = function () {
    var setFilterConfiguration = useFilterConfigStore().setFilterConfiguration;
    var _a = useFilterStore(), filters = _a.filters, updateFilter = _a.updateFilter;
    var data = localStorage.getItem('modular-filter-storage');
    var legacyData = JSON.parse(data).state;
    var _b = useState([]), migrationsStarted = _b[0], setMigrationsStarted = _b[1];
    Object.values(legacyData.importedModularFilters).forEach(function (_a, index) {
        var _b;
        var id = _a.id, name = _a.name, active = _a.active, source = _a.source;
        var url = null;
        if (typeof source === 'string') {
            url = source;
        }
        else if (typeof source === 'object' &&
            source.owner &&
            source.repo) {
            url = legacyFilterUrls["".concat(source.owner, ":").concat(source.repo)];
        }
        if (!url || migrationsStarted.includes(id)) {
            return;
        }
        setMigrationsStarted(function (prev) { return __spreadArray(__spreadArray([], prev, true), [id], false); });
        var configs = (_b = legacyData.filterConfigurations[id]) !== null && _b !== void 0 ? _b : {};
        loadFilterFromUrl(url)
            .then(function (filter) {
            setMigrationsStarted(function (prev) {
                return prev.filter(function (id) { return id !== id; });
            });
            // Only migrate if the filter doesn't exist yet
            // to avoid overwriting any changes
            if (filters[id] === undefined) {
                updateFilter(__assign(__assign({}, filter), { id: id, name: name, active: active }));
                setFilterConfiguration(id, configs);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    });
    var checkMigrations = function () {
        if (migrationsStarted.length === 0) {
            localStorage.setItem('modular-filter-storage-migrated', new Date().toISOString());
            window.location.reload();
        }
        else {
            setTimeout(checkMigrations, 1000);
        }
    };
    setTimeout(checkMigrations, 1000);
    return (_jsx("div", __assign({ style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        } }, { children: _jsxs("div", { children: [_jsxs(Typography, __assign({ variant: "h6", color: "primary" }, { children: ["Legacy data detected, migrating...", _jsx(CircularProgress, {})] })), _jsx(Typography, __assign({ variant: "h6", color: "primary" }, { children: "Page will reload when done." }))] }) })));
};
